"use client";

import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

import { VideoReview } from "@/app/(marketing)/components/reviews/VideoReview";
import { Carousel } from "@/components/carousel/Carousel";
import { CarouselContent } from "@/components/carousel/CarouselContent";
import { CarouselItem } from "@/components/carousel/CarouselItem";
import { CarouselNext } from "@/components/carousel/CarouselNext";
import { CarouselPrevious } from "@/components/carousel/CarouselPrevious";
import { type CarouselApi } from "@/components/carousel/types";
import { NormalText } from "@/components/text/NormalText";
import thumbnail1 from "@/public/images/youtubeThumbnails/mha/1.jpg";
import thumbnail2 from "@/public/images/youtubeThumbnails/mha/2.jpeg";
import thumbnail3 from "@/public/images/youtubeThumbnails/mha/3.jpeg";
import thumbnail4 from "@/public/images/youtubeThumbnails/mha/4.jpg";
import { VideoReviewType } from "@/types/types";

const videos: VideoReviewType[] = [
  {
    youtubeVideoId: "PYFz_BYlYt0",
    image: thumbnail1,
    imageAlt: "Image of MHA video 1",
  },
  {
    youtubeVideoId: "Y11J2qSrCD0",
    image: thumbnail2,
    imageAlt: "Image of MHA video 2",
  },
  {
    youtubeVideoId: "dIcnkul6HNQ",
    image: thumbnail3,
    imageAlt: "Image of MHA video 3",
  },
  {
    youtubeVideoId: "fH3PYlPywww",
    image: thumbnail4,
    imageAlt: "Image of MHA video 4",
  },
];

export function MhaVideos({ className }: { className?: string }) {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (api === undefined) {
      return;
    }

    setCurrent(api.selectedScrollSnap() + 1);

    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);

  return (
    <div className={twMerge("", className)}>
      <Carousel
        setApi={setApi}
        className="mx-auto w-full max-w-2xl"
        opts={{
          startIndex: 1,
        }}
      >
        <CarouselContent className="overflow-hidden">
          {videos.map((video) => (
            <CarouselItem key={video.youtubeVideoId}>
              <div className="flex w-full">
                <VideoReview videoReview={video} />
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious />
        <CarouselNext />
      </Carousel>
      <NormalText elementType="p" className="mt-2 text-center">
        Video {current} of {videos.length}
      </NormalText>
    </div>
  );
}
